import React from "react";
import { Autocomplete, TextField } from "@mui/material";
import { useQuery } from "@tanstack/react-query";
import HttpService from "../services/HttpService";

// Fetch card products based on selected employer
async function fetchCardProducts(employerId) {
  if (!employerId) return { data: [] };

  const response = await HttpService.getAxiosClient().get(
    window.API_URL + `/employer/${employerId}/cardproducts`
  );
  return response;
}

const RuleTargetSelector = ({ 
  formik 
}) => {
  const { data: cardProductsData, isLoading: isLoadingCardProducts } = useQuery(
    ["cardProducts", formik.values.companiesList?.idEmployer],
    () => fetchCardProducts(formik.values.companiesList?.idEmployer),
    {
      enabled: !!formik.values.companiesList?.idEmployer,
    }
  );
  return (
    <Autocomplete
      fullWidth
      id="ruleTargetProduct"
      options={!isLoadingCardProducts ? (Array.isArray(cardProductsData?.data) ? cardProductsData?.data : []) : []}
      getOptionLabel={(option) => 
        `${option.name || ''}`
      }
      filterSelectedOptions
      value={formik.values.ruleTargetProduct}
      onChange={(event, selectedOption) => {
        formik.setFieldValue("ruleTargetProduct", selectedOption);
      }}
      disabled={!formik.values.companiesList?.idEmployer}
      renderInput={(params) => (
        <TextField
          {...params}
          error={formik.touched.ruleTargetProduct && Boolean(formik.errors.ruleTargetProduct)}
          helperText={
            (formik.touched.ruleTargetProduct && formik.errors.ruleTargetProduct) ||
            (!formik.values.companiesList?.idEmployer ? "Select a company first" : "")
          }
          label="Target Product"
          placeholder={formik.values.companiesList?.idEmployer ? "Select a card product" : "Select a company first"}
        />
      )}
    />
  );
};

export default RuleTargetSelector;
